/* RESPONSIBLE TEAM: team-inbox */
export interface TeamSettingsWireFormat {
  id: number;
  assignment_distribution: string;
  volume_control_enabled: boolean;
  assignment_limit?: number;
}

export default class TeamSettings {
  readonly id: number;
  readonly assignmentDistribution: string;
  readonly volumeControlEnabled: boolean;
  readonly assignmentLimit?: number;

  constructor(
    id: number,
    assignmentDistribution: string,
    volumeControlEnabled: boolean,
    assignmentLimit?: number,
  ) {
    this.id = id;
    this.assignmentDistribution = assignmentDistribution;
    this.volumeControlEnabled = volumeControlEnabled;
    this.assignmentLimit = assignmentLimit;
  }

  static deserialize(json: TeamSettingsWireFormat): TeamSettings {
    return new TeamSettings(
      json.id,
      json.assignment_distribution,
      json.volume_control_enabled,
      json.assignment_limit,
    );
  }
}
